"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Setting = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var index_1 = require("../index");
var styles_1 = require("@material-ui/styles");
var react_router_dom_1 = require("react-router-dom");
var useMediaQuery_1 = tslib_1.__importDefault(require("@material-ui/core/useMediaQuery"));
var styles_2 = require("@material-ui/core/styles");
var index_2 = tslib_1.__importDefault(require("../theme-wrap/app-theme/index"));
var useStyles = styles_1.makeStyles({
    setting: {
        display: "flex",
        justifyContent: "center",
        height: "100%",
    },
    settingLeft: {
        display: "flex",
        justifyContent: "flex-end",
        width: "30%",
        height: "100%",
    },
    settingRight: {
        display: "flex",
        justifyContent: "flex-start",
        width: "70%",
        height: 1500,
    },
    directory: {
        display: "flex",
        flexDirection: "column",
        width: 192,
        paddingTop: 60,
        paddingRight: 6,
        paddingBottom: 60,
        paddingLeft: 20,
    },
    content: {
        width: 740,
    },
});
function Setting(props) {
    var data = props.data;
    var classes = useStyles();
    var prefersDarkMode = useMediaQuery_1.default("(prefers-color-scheme: dark)");
    var theme = react_1.default.useMemo(function () {
        var themeType = prefersDarkMode ? "dark" : "light";
        return styles_2.createMuiTheme({
            app: index_2.default(themeType),
            palette: {
                type: themeType,
                isDark: prefersDarkMode,
            },
        });
    }, [prefersDarkMode]);
    return (react_1.default.createElement(styles_2.ThemeProvider, { theme: theme },
        react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
            react_1.default.createElement("div", { className: classes.setting },
                react_1.default.createElement("div", { className: classes.settingLeft },
                    react_1.default.createElement("div", { className: classes.directory },
                        react_1.default.createElement(index_1.SettingDirectory, { data: data.nodes }),
                        react_1.default.createElement(index_1.SettingHintIcon, { data: [
                                {
                                    icon: "4k",
                                    url: "https://t.bilibili.com",
                                },
                                {
                                    icon: "pets",
                                    url: "https://t.bilibili.com",
                                },
                                {
                                    icon: "facebook",
                                    url: "https://t.bilibili.com",
                                },
                            ] }),
                        react_1.default.createElement(index_1.SettingHintText, { text: "Stable 58202 (6914c16)", des: "OS X 10.15.4 64-Bit" }))),
                react_1.default.createElement("div", { className: classes.settingRight },
                    react_1.default.createElement("div", { className: classes.content },
                        react_1.default.createElement(index_1.SettingContent, null)))))));
}
exports.Setting = Setting;
//# sourceMappingURL=index.js.map